import { AudioHighlightMetadata } from '@modules/feedback/components/AudioType/types';
import { isSummaryHighlightMetadataType } from '@modules/feedback/components/AudioType/utils';

const hasLabelMatchForHighlightMetadataIndex = (
  highlightMetadata: AudioHighlightMetadata[],
  labelID: string,
  index: number,
) => {
  return (
    highlightMetadata.findIndex(
      (highlight) => highlight.labelID === labelID,
    ) === index
  );
};

export const getUniqueHighlightMetadata = (
  highlightMetadata: AudioHighlightMetadata[],
  shouldContainSummary?: boolean,
) => {
  return highlightMetadata.filter((highlight, index) => {
    if (shouldContainSummary) {
      return (
        isSummaryHighlightMetadataType(highlight) &&
        hasLabelMatchForHighlightMetadataIndex(
          highlightMetadata,
          highlight.labelID,
          index,
        )
      );
    }

    return hasLabelMatchForHighlightMetadataIndex(
      highlightMetadata,
      highlight.labelID,
      index,
    );
  });
};
